import {KTIcon} from '../../../../_metronic/helpers'
import {ListViewProvider} from '../../../utils/contextProvider/ListViewProvider'
import {useRouteManagement} from '../RouteManagementProvider'
import {useSelectSender} from '../SelectSenderProvider'
import SenderSelection from './SenderSelection'

const SelectSenderId = () => {
  const {showSenderModal, setShowSenderModal} = useRouteManagement()

  const onClose = () => {
    setShowSenderModal(false)
  }

  // Stop propagation on modal content to prevent focus issues
  const handleModalContentClick = (e: React.MouseEvent) => {
    e.stopPropagation()
  }

  return (
    <div className={`modal custom-overlay ${showSenderModal ? 'd-block' : ''}`}>
      {/* begin::Modal dialog */}
      <div
        className='modal-dialog modal-xl w-100 p-12'
        onClick={handleModalContentClick} // Prevent clicks from closing modal
      >
        {/* begin::Modal content */}
        <div className='modal-content'>
          <div className='modal-header'>
            <h5 className='modal-title fs-2'>Sender Selection</h5>
            <div
              className='btn btn-icon btn-sm btn-active-light-primary ms-2'
              onClick={onClose}
              data-bs-toggle='modal'
              data-bs-target='#kt_modal_1'
            >
              <KTIcon iconName='cross' className='fs-1' />
            </div>
          </div>
          {/* begin::Modal body */}
          <div className='modal-body scroll-y my-5 mx-10'>
            <SenderSelection />
          </div>

          <div className=''>
            {/* <div className='text-center'>
              <button
                type='reset'
                className='btn btn-light me-3'
                onClick={onClose}
                data-bs-toggle='modal'
                data-bs-target='#kt_modal_1'
              >
                Close
              </button>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  )
}

export default SelectSenderId
